export default "__VITE_ASSET__Ds4e7Hxd__"